import { FC } from "react"

interface props {
    path: string
    altText: string
    className: string
    errorPath : string
    title ?: string
}

const ImageDisplay: FC<props> = ({ path, altText, className, errorPath, title }) => {
    return (
        <img
            src={path}
            alt={altText}
            className={className}
            onError={(event: any) => {
                event.target.src = errorPath;
                event.onerror = null;
            }}
            title={title ? title : ""}
        />
    )
}

export default ImageDisplay